import React from "react";
import { string, node, number } from "prop-types";
import Block from "../../../Block";
import Button from "../../../Button";
import { Col, Row } from "../../../Grid";
import Image from "../../../Image";
import Heading from "../../../Heading";
import Paragraph from "../../../Paragraph";
import Link from "../../../Link";
import ContentContainer from "../../atoms/ContentContainer";
import Section from "../../../Section";

const HomepageHero = ({ children }) => {
	return (
		<Section utility={{ border: { bottom: { width: 1, color: "black--15" } } }} spacing={{ pb: 5 }}>
			<ContentContainer lg={8} center>
				{children}
			</ContentContainer>
		</Section>
	);
};

HomepageHero.propTypes = {
	children: node.isRequired,
};

const HomepageHeroHead = ({ children, srcHeroHeadImg }) => {
	return (
		<>
			<Row>{children}</Row>
			{srcHeroHeadImg ? (
				<Row>
					<Col>
						<Block spacing={{ mt: 10, mb: 30 }}>
							<Image src={srcHeroHeadImg} />
						</Block>
					</Col>
				</Row>
			) : null}
		</>
	);
};

HomepageHeroHead.propTypes = {
	children: node.isRequired,
	srcHeroHeadImg: string,
};

const HomepageHeroTitle = ({ children }) => {
	return (
		<Col>
			<Heading Tag="h1" sx={{ fontSize: "xxl", textAlign: "center" }} spacing={{ mt: 20 }}>
				{children}
			</Heading>
		</Col>
	);
};

HomepageHeroTitle.propTypes = {
	children: string.isRequired,
};

const HomepageHeroDescription = ({ children }) => {
	return (
		<Col>
			<Paragraph sx={{ fontSize: "l", textAlign: "center" }}>{children}</Paragraph>
		</Col>
	);
};

HomepageHeroDescription.propTypes = {
	children: string.isRequired,
};

const HomepageHeroButtons = ({ children }) => {
	return (
		<Col>
			<Block sx={{ textAlign: "center" }} spacing={{ mt: 4 }}>
				{children}
			</Block>
		</Col>
	);
};

HomepageHeroButtons.propTypes = {
	children: node.isRequired,
};

const HomepageHeroLinks = ({ children }) => {
	return (
		<Col>
			<Block sx={{ textAlign: "center" }} spacing={{ mt: 15 }}>
				{children}
			</Block>
		</Col>
	);
};

HomepageHeroLinks.propTypes = {
	children: node.isRequired,
};

export const HomepageHeroHeadLink = ({ children, ...props }) => {
	return (
		<Link sx={{ fontSize: "s", fontColor: "black" }} {...props} className="text-underline">
			{children}
		</Link>
	);
};

HomepageHeroHeadLink.propTypes = {
	children: string.isRequired,
};
HomepageHeroDescription.propTypes = {
	children: string.isRequired,
};

export const HomepageHeroButtonDefault = ({ children, ...props }) => {
	return (
		<Button.Link size="s" spacing={{ mr: 4 }} {...props}>
			{children}
		</Button.Link>
	);
};

HomepageHeroButtonDefault.propTypes = {
	children: string.isRequired,
};

export const HomepageHeroButtonSecondary = ({ children, ...props }) => {
	return (
		<Button.Link size="s" styleType="secondary" isOutline2 {...props}>
			{children}
		</Button.Link>
	);
};

HomepageHeroButtonSecondary.propTypes = {
	children: string.isRequired,
};

const HomepageHeroBody = ({ children }) => {
	return <Row>{children}</Row>;
};

HomepageHeroBody.propTypes = {
	children: node.isRequired,
};

const HomepageHeroBodyItem = ({ numItem, title, description, srcImg, href, children }) => {
	return (
		<Col spacing={{ mb: 20 }}>
			<Row>
				<Col lg={5} className="overflow-hidden">
					<Block spacing={{ md: { mt: "m3" } }}>
						<Row middle>
							<Col shrink spacing={{ mr: 4 }}>
								<span className="heading heading-xxxl">{numItem}</span>
							</Col>
							<Col auto>
								<Heading Tag="h2" sx={{ fontSize: "l" }} spacing={{ my: 0 }}>
									{title}
								</Heading>
							</Col>
						</Row>
					</Block>
				</Col>
				<Col lg={7}>
					<Paragraph sx={{ fontSize: "m" }} spacing={{ mt: 0, mb: 2 }}>
						{description}
					</Paragraph>
					<Paragraph spacing={{ my: 0 }}>{children}</Paragraph>
				</Col>
			</Row>
			<Row>
				<Col>
					<Block spacing={{ mt: 4 }}>
						<Link href={href} isBaseClassName={false} utility={{ display: "block" }}>
							<Image src={srcImg} alt={title} />
						</Link>
					</Block>
				</Col>
			</Row>
		</Col>
	);
};

HomepageHeroBodyItem.propTypes = {
	numItem: number.isRequired,
	title: string.isRequired,
	description: string.isRequired,
	srcImg: string.isRequired,
	href: string.isRequired,
	children: node.isRequired,
};

export const HomepageHeroBodyItemLink = ({ children, href, ...props }) => {
	return (
		<Link sx={{ fontSize: "s" }} href={href} {...props}>
			{children}
		</Link>
	);
};

HomepageHeroBodyItemLink.propTypes = {
	children: string.isRequired,
	href: string.isRequired,
};

HomepageHero.Head = HomepageHeroHead;
HomepageHeroHead.Title = HomepageHeroTitle;
HomepageHeroHead.Description = HomepageHeroDescription;
HomepageHeroHead.Buttons = HomepageHeroButtons;
HomepageHeroHead.Links = HomepageHeroLinks;

HomepageHero.Body = HomepageHeroBody;
HomepageHero.Body.Item = HomepageHeroBodyItem;
export default HomepageHero;
